/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 */
import { RouteConfig } from 'vue-router';
import Single from '@/views/Dev/Single.vue';

export const dev: RouteConfig[] = [
  {
    path: '/single',
    name: 'dev.single',
    component: Single
  }
];
